module.exports = "static/assets/048d12d9e01a42ab48fb6ce57100f6f8.mp3";